import { render, staticRenderFns } from "./TravellersScanReport.vue?vue&type=template&id=e353930c&"
import script from "./TravellersScanReport.vue?vue&type=script&lang=js&"
export * from "./TravellersScanReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports